// Fase 33 — Lookup e associação de códigos de barras EAN-13 a produtos
// (bebidas e menuItems) cadastrados no estoque/cardápio.

import db from '@/db';

function normalize(code) {
  return String(code || '').replace(/\D/g, '').trim();
}

/**
 * Busca um produto cadastrado pelo código de barras EAN-13.
 * Procura primeiro em `beverages`, depois em `menuItems`.
 * Retorna `{ kind: 'beverage'|'menuItem', product } | null`.
 */
export async function findProductByBarcode(code) {
  const c = normalize(code);
  if (!c) return null;
  // beverages
  const bev = await db.beverages.filter((b) => normalize(b.barcode) === c).first();
  if (bev) return { kind: 'beverage', product: bev };
  // menuItems
  const mi = await db.menuItems.filter((m) => normalize(m.barcode) === c).first();
  if (mi) return { kind: 'menuItem', product: mi };
  return null;
}

/**
 * Associa um código de barras a uma bebida existente (cadastro rápido).
 */
export async function linkBarcodeToBeverage(beverageId, barcode) {
  const c = normalize(barcode);
  if (!c) throw new Error('Código inválido');
  const existing = await findProductByBarcode(c);
  if (existing && existing.product.id !== beverageId) {
    throw new Error(`Código já cadastrado em "${existing.product.name}"`);
  }
  await db.beverages.update(beverageId, { barcode: c });
  return db.beverages.get(beverageId);
}

/**
 * Associa um código de barras a um menuItem existente.
 */
export async function linkBarcodeToMenuItem(menuItemId, barcode) {
  const c = normalize(barcode);
  if (!c) throw new Error('Código inválido');
  const existing = await findProductByBarcode(c);
  if (existing && existing.product.id !== menuItemId) {
    throw new Error(`Código já cadastrado em "${existing.product.name}"`);
  }
  await db.menuItems.update(menuItemId, { barcode: c });
  return db.menuItems.get(menuItemId);
}
